// src\store\index.js

import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/utils/axios'  // ✅ 直接引入 axios
import { authBaseURL } from '@/utils/axios'



import { allDynamicRoutes } from '@/router' // 为了获取路由路径

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        permissions: [],
        userInfo: null // 新增用户信息状态
    },
    mutations: {
        SET_PERMISSIONS(state, permissions) {
            state.permissions = permissions
        },
        SET_USER_INFO(state, info) { // 新增 mutation
            state.userInfo = info
        }
    },
    actions: {
        async fetchUserPermissions({ commit }) {
            try {
                const res = await axios.post('/api/menus/check', {
                    routes  : allDynamicRoutes.map(r => r.path)
                })
                const permissions = res.data.data.allowed || []

                const dev = false // 开发环境下直接使用所有动态路由
                if (dev) {
                    commit('SET_PERMISSIONS', allDynamicRoutes.map(r => r.path))
                    return allDynamicRoutes.map(r => r.path)
                } else {
                    commit('SET_PERMISSIONS', permissions)
                    return permissions
                }

            } catch (error) {
                console.error('获取权限失败:', error)
                return []
            }
        },
        // 新增用户信息获取方法
        async getInfo({ commit }) {
            try {
                const res = await axios.get(`${authBaseURL}/auth/userinfo`) // 根据您的API调整端点
                commit('SET_USER_INFO', res.data.data)
                return res.data.data
            } catch (error) {
                console.error('获取用户信息失败:', error)
                throw error // 抛出错误以便组件处理
            }
        }
    },
    getters: {
        permissions: state => state.permissions,
        hasPermission: state => routePath => {
            return state.permissions.includes(routePath)
        },
        userInfo: state => state.userInfo // 新增 getter
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js